import http from "./http.config";
import { type ApiEnvelope, unwrapApiResponse } from "./api.utils";

export type QuotationDetailResponse = {
  id: number;
  quote_number: string;
  expiry_date: string | null;
  description: string | null;
  status: string;
  schedule_label: string | null;
  created_at: string | null;
  client?: {
    id?: number;
    name?: string | null;
    email?: string | null;
    phone_no?: string | null;
  } | null;
  vendor?: {
    id: number;
    address?: string | null;
    code: string | null;
    logo?: string | null;
    publishable_key?: string | null;
    name?: string | null;
    company_name?: string | null;
  } | null;
  sections?: Array<{
    title?: string | null;
    description?: string | null;
    items?: Array<{
      title?: string | null;
      price?: number | string | null;
      qty?: number | string | null;
      line_total?: number | string | null;
    }>;
  }>;
  total_info?: {
    sub_total?: number | string | null;
    tax_amount?: number | string | null;
    total_amount?: number | string | null;
  } | null;
};

export const fetchQuotations = (params = {}) =>
  http.get("/quotations", { params }).then((res) => res.data);

export const fetchCustomerQuotations = (params = {}) =>
  http.get("/customers/quotations", { params }).then((res) => res.data);

export const fetchVendorQuotations = (params = {}) =>
  http.get("/vendors/quotations", { params }).then((res) => res.data);

export const fetchQuotationById = (id: string | number, params = {}) =>
  http
    .get<QuotationDetailResponse | ApiEnvelope<QuotationDetailResponse>>(
      `/quotations/${id}`,
      { params },
    )
    .then((res) => unwrapApiResponse(res.data));

export const fetchVendorQuotationDetail = (id: string | number, params = {}) =>
  http
    .get<QuotationDetailResponse | ApiEnvelope<QuotationDetailResponse>>(
      `/vendors/quotations/${id}/details`,
      { params },
    )
    .then((res) => unwrapApiResponse(res.data));

export const fetchCustomerQuotationDetail = (id: string | number, params = {}) =>
  http
    .get<QuotationDetailResponse | ApiEnvelope<QuotationDetailResponse>>(
      `/customers/quotations/${id}/details`,
      { params },
    )
    .then((res) => unwrapApiResponse(res.data));

export const acceptQuotation = (id: string | number) =>
  http
    .post(`/quotations/${id}/accept`)
    .then((res) => unwrapApiResponse(res.data));

export const acceptQuotationWithAppointment = (
  id: string | number,
  payload: {
    preferred_date: string;
    preferred_time: string;
  },
) =>
  http
    .post(`/customers/quotations/${id}/convert`, payload)
    .then((res) => unwrapApiResponse(res.data));

export const rejectQuotation = (
  id: string | number,
  payload: { reason: string } = { reason: "" },
) =>
  http
    .post(`/quotations/${id}/reject`, payload)
    .then((res) => unwrapApiResponse(res.data));

export const quotationConvert = (id: string | number, payload: Record<string, any> = {}) =>
  http
    .post(`/vendors/quotations/${id}/convert`, payload)
    .then((res) => unwrapApiResponse(res.data));

export const sendQuotation = (
  id: string | number,
  payload: {
    quotation_template_id?: string | number;
    summary?: {
      sub_total?: number;
      tax_amount?: number;
      vendor_commission?: number;
      company_fee?: number;
      total_amount?: number;
    };
  } = {},
) =>
  http
    .post(`/inquiries/${id}/send-quotation`, payload)
    .then((res) => unwrapApiResponse(res.data));
